import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { SubdistrictCreateForm } from "@/features/subdistrict/SubdistrictCreateForm";

export function SubdistrictCreate() {
  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "Master Data",
          },
          {
            href: "/master-data/district",
            label: "District (Kec)",
          },
          {
            label: "Add",
          },
        ]}
      />
      <H2>Add District (Kec)</H2>
      <SubdistrictCreateForm />
    </>
  );
}
